import React, { Component } from "react";

import PlaybookRunService from "../../services/PlaybookRunService";

import "./agent-finding-counts.css";

const SEVERITIES = ["high", "medium", "low"];

class AgentFindingCounts extends Component {
	render() {
		const { run, size = "regular" } = this.props;
		const hasRun = run.status === "needs_review" || run.status === "completed";
		const isSpread = size === "spread";
		if (!hasRun) return isSpread ? null : <span className="agent-finding-counts__none">—</span>;

		const counts = PlaybookRunService.countFindings({ run });
		const severities = SEVERITIES.filter(severity => isSpread || counts[severity] > 0);
		if (!SEVERITIES.some(severity => counts[severity] > 0)) return <span className="agent-finding-counts__none">No findings</span>;

		return (
			<span className={`agent-finding-counts agent-finding-counts--${size}`}>
				{severities.map(severity => (
					<span key={severity} className={`agent-finding-counts__item agent-finding-counts__item--${severity}`}>
						{isSpread && <span className={`agent-finding-counts__dot agent-finding-counts__dot--${severity}`} aria-hidden="true" />}
						<span className="agent-finding-counts__number">{counts[severity]}</span> {severity}
					</span>
				))}
			</span>
		);
	}
}

export default AgentFindingCounts;
